import { render, staticRenderFns } from "./MessagePopupLayout.vue?vue&type=template&id=fcc10722&scoped=true&"
import script from "./MessagePopupLayout.vue?vue&type=script&lang=js&"
export * from "./MessagePopupLayout.vue?vue&type=script&lang=js&"
import style0 from "./MessagePopupLayout.vue?vue&type=style&index=0&id=fcc10722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc10722",
  null
  
)

export default component.exports